async function fetchFAQs(first = 250) {
    const SHOPIFY_STORE_DOMAIN = 'almalaky-dubai.myshopify.com';
    const SHOPIFY_API_VERSION = '2024-04';
    const SHOPIFY_STOREFRONT_TOKEN = 'c32ab4ee28ae1c7444449269579675e4';
   
    const query = `
      query GetFAQs($first: Int!)@inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
        metaobjects(type: "faq_accordions", first: $first) {
          edges {
            node {
              id
              handle
              fields {
                key
                value
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor 
          }
        }
      }
    `;
  
    try {
      const response = await fetch(`https://${SHOPIFY_STORE_DOMAIN}/api/${SHOPIFY_API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
        },
        body: JSON.stringify({
          query,
          variables: {
            first,
          },
        }),
      });
  
      const data = await response.json();
      console.log(  'FAQ fetch response data:', data);
      if (data.errors) {
        console.error("Error fetching FAQs:", data.errors);
        return [];
      } else {
        const faqs = data.data.metaobjects.edges.map(edge => {
          const node = edge.node;
          const faqData = {};
          
          // Convert fields array to object properties
          node.fields.forEach(field => {
            faqData[field.key] = field.value;
          });
          
          faqData.id = node.id;
          faqData.handle = node.handle;
          
          return faqData;
        });
        
        return faqs;
      }
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      return [];
    }
  }
  
  // Process FAQs and update the UI
  async function processFAQs() {
    const faqs = await fetchFAQs(250); // Fetch up to 250 FAQs
    if (!faqs.length) return;
    
    // Add CSS for the icons
    addIconStyles();
    
    // Log the total number of FAQs fetched
    // console.log(`Total FAQ entries fetched: ${faqs.length}`);
    
    // Log array indices for each FAQ
    logFAQIndices(faqs);
    
    // Group FAQs by tab title
    const faqsByTab = {};
    
    faqs.forEach(faq => {
      const tabTitle = faq.tab_title || 'General';
      if (!faqsByTab[tabTitle]) {
        faqsByTab[tabTitle] = [];
      }
      faqsByTab[tabTitle].push(faq);
    });
    
    // Log the number of FAQs in each tab
    // console.log('FAQs grouped by tab:');
    Object.keys(faqsByTab).forEach(tabTitle => {
      // console.log(`- ${tabTitle}: ${faqsByTab[tabTitle].length} entries`);
    });
    
    // Get existing tab containers
    const tabsContainer = document.querySelector('.faq-tab-buttons');
    const contentsContainer = document.querySelector('.faq-contents');
    
    if (!tabsContainer || !contentsContainer) return;
    
    // Clear existing tabs and content
    tabsContainer.innerHTML = '';
    contentsContainer.innerHTML = '<div id="noResults" style="display: none;">No Results Found</div>';
    
    // Create tabs and content for each group
    Object.keys(faqsByTab).forEach((tabTitle, index) => {
      const tabId = faqsByTab[tabTitle][0]?.handle || handleize(tabTitle);
      
      // Create tab button
      const tabButton = document.createElement('div');
      tabButton.className = 'faq-tab-button';
      tabButton.id = tabId;
      if (index === 0) tabButton.classList.add('active-tab');
      tabButton.innerHTML = `<h6 class="tab--title">${tabTitle}</h6>`;
      tabsContainer.appendChild(tabButton);
      
      // Create tab content container
      const tabContent = document.createElement('div');
      tabContent.className = 'faq-tab-content';
      tabContent.dataset.id = tabId;
      tabContent.style.display = index === 0 ? 'block' : 'none';
      
      // Add FAQs to this tab
      faqsByTab[tabTitle].forEach(faq => {
        const faqElement = document.createElement('div');
        faqElement.className = 'faq-main';
        faqElement.innerHTML = `
          <div class="faq-question">
            <h6 class="question">
              <span>${faq.accordion_heading || ''}</span>
              <span class="faq-icons">
                <svg class="plus-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                <svg class="minus-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </span>
            </h6>
          </div>
          <div class="faq-answer" style="display: none;">
            ${parseRichText(faq.accordion_content)}
          </div>
        `;
        tabContent.appendChild(faqElement);
      });
      
      contentsContainer.appendChild(tabContent);
    });
    
    // Re-initialize event listeners
    initFAQEventListeners();
  }
  
  // Helper function to handleize strings
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }
  
  // Render a node and its children
  function renderNode(node) {
    if (!node || !node.type) return '';
    
    switch (node.type) {
      case 'paragraph':
        return `<p>${node.children ? node.children.map(child => renderNode(child)).join('') : ''}</p>`;
      case 'heading':
        const level = node.level || 2;
        return `<h${level}>${node.children ? node.children.map(child => renderNode(child)).join('') : ''}</h${level}>`;
      case 'text':
        let text = node.value || '';
        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        if (node.underline) text = `<u>${text}</u>`;
        return text;
      case 'list':
        const listType = node.listType === 'ordered' ? 'ol' : 'ul';
        // Ensure each child of a list is wrapped in an li tag if not already
        const listItems = node.children ? node.children.map(child => {
          if (child.type === 'listItem') {
            return renderNode(child);
          } else {
            return `<li>${renderNode(child)}</li>`;
          }
        }).join('') : '';
        return `<${listType}>${listItems}</${listType}>`;
      case 'listItem':
        return `<li>${node.children ? node.children.map(child => renderNode(child)).join('') : ''}</li>`;
      case 'link':
        return `<a href="${node.url || '#'}" ${node.newTab ? 'target="_blank"' : ''}>${node.children ? node.children.map(child => renderNode(child)).join('') : ''}</a>`;
      default:
        return node.children ? node.children.map(child => renderNode(child)).join('') : (node.value || '');
    }
  }
  
  // Add a debug function to log the structure of rich text content
  function debugRichTextStructure(content) {
    try {
      const parsedContent = typeof content === 'string' ? JSON.parse(content) : content;
      // console.log('Rich text structure:', JSON.stringify(parsedContent, null, 2));
      return parsedContent;
    } catch (error) {
      console.error('Error parsing content for debug:', error);
      return content;
    }
  }
  
  // Update the parseRichText function to include debugging
  function parseRichText(jsonContent) {
    try {
      if (!jsonContent) return '';
      
      // If it's already a parsed object, use it directly
      let content;
      try {
        content = typeof jsonContent === 'string' ? JSON.parse(jsonContent) : jsonContent;
        // Debug the first few items to understand structure
        // console.log('Sample rich text structure:', JSON.stringify(content, null, 2));
      } catch (e) {
        console.error('JSON parse error:', e);
        return jsonContent; // Return as-is if not valid JSON
      }
      
      // Special handling for Shopify metafield format
      if (content.type === 'root' && content.children) {
        return content.children.map(child => renderNode(child)).join('');
      }
      
      // Handle arrays of content
      if (Array.isArray(content)) {
        return content.map(item => renderNode(item)).join('');
      }
      
      return renderNode(content);
    } catch (error) {
      console.error('Error parsing rich text:', error);
      return jsonContent || ''; // Return original content if parsing fails
    }
  }
  
  // Initialize event listeners
  function initFAQEventListeners() {
    const searchInput = document.getElementById('faqSearch');
    const tabButtons = document.querySelectorAll('.faq-tab-button');
    const tabContents = document.querySelectorAll('.faq-tab-content');
    const noResults = document.getElementById('noResults');
    
    // Search functionality
    searchInput.addEventListener('input', () => {
      const searchTerm = searchInput.value.trim().toLowerCase();
      filterFAQs(searchTerm);
    });
    
    // Tab switching
    tabButtons.forEach(tab => {
      tab.addEventListener('click', () => {
        tabButtons.forEach(t => t.classList.remove('active-tab'));
        tab.classList.add('active-tab');
        
        const tabId = tab.getAttribute('id');
        tabContents.forEach(content => {
          content.style.display = content.getAttribute('data-id') === tabId ? 'block' : 'none';
        });
        
        filterFAQs(searchInput.value.trim().toLowerCase());
      });
    });
    
    // FAQ accordion functionality
    document.addEventListener('click', function(e) {
      if (e.target.closest('.faq-question')) {
        const question = e.target.closest('.faq-question');
        const answer = question.nextElementSibling;
        
        if (question.classList.contains('open')) {
          question.classList.remove('open');
          answer.style.display = 'none';
        } else {
          question.classList.add('open');
          answer.style.display = 'block';
        }
      }
    });
  }
  
  // Filter FAQs based on search term
  function filterFAQs(searchTerm) {
    const tabButtons = document.querySelectorAll('.faq-tab-button');
    const tabContents = document.querySelectorAll('.faq-tab-content');
    const noResults = document.getElementById('noResults');
    let hasVisible = false;
    
    const activeTabId = (() => {
      const activeBtn = document.querySelector('.faq-tab-button.active-tab');
      return activeBtn ? activeBtn.getAttribute('id') : (tabButtons.length > 0 ? tabButtons[0].getAttribute('id') : null);
    })();
    
    if (!activeTabId) return;
    
    tabContents.forEach(content => {
      const belongsToTab = content.getAttribute('data-id') === activeTabId;
      
      if (belongsToTab) {
        const faqBlocks = content.querySelectorAll('.faq-main');
        
        // If no search term, show all FAQs in the active tab
        if (!searchTerm) {
          faqBlocks.forEach(block => {
            block.style.display = 'block';
          });
          hasVisible = faqBlocks.length > 0;
          content.style.display = 'block';
        } else {
          // Filter by search term
          faqBlocks.forEach(block => {
            const question = block.querySelector('.question')?.textContent.toLowerCase() || '';
            const answer = block.querySelector('.faq-answer')?.textContent.toLowerCase() || '';
            
            if (question.includes(searchTerm) || answer.includes(searchTerm)) {
              block.style.display = 'block';
              hasVisible = true;
            } else {
              block.style.display = 'none';
            }
          });
          content.style.display = 'block';
        }
      } else {
        content.style.display = 'none';
      }
    });
    
    if (noResults) {
      noResults.style.display = hasVisible ? 'none' : 'block';
    }
  }
  
  // Add CSS styles for the FAQ icons
  function addIconStyles() {
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      .faq-icons {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .faq-icons .plus-icon {
        display: block;
      }
      .faq-icons .minus-icon {
        display: none;
      }
      .faq-question.open .faq-icons .plus-icon {
        display: none;
      }
      .faq-question.open .faq-icons .minus-icon {
        display: block;
      }
    `;
    document.head.appendChild(styleEl);
  }
  
  // Run when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Hide the "No Results" message on page load
    const noResults = document.getElementById('noResults');
    if (noResults) {
      noResults.style.display = 'none';
    }
    
    processFAQs();
  });
  
  // Log array indices for each FAQ entry grouped by tab title
  function logFAQIndices(faqs) {
    // Group by tab title
    const groupedByTab = {};
    
    faqs.forEach((faq, index) => {
      const tabTitle = faq.tab_title || 'General';
      if (!groupedByTab[tabTitle]) {
        groupedByTab[tabTitle] = [];
      }
      
      // Store index and heading for easy identification
      groupedByTab[tabTitle].push({
        index,
        heading: faq.accordion_heading || `FAQ #${index}`,
        id: faq.id
      });
    });
    
    // Log in a structured format
    // console.log('=== FAQ ENTRIES BY TAB (WITH INDICES) ===');
    // Object.keys(groupedByTab).forEach(tabTitle => {
    //   // console.log(`\n## TAB: ${tabTitle} (${groupedByTab[tabTitle].length} entries)`);
    //   console.table(groupedByTab[tabTitle].map((item, localIndex) => ({
    //     'Global Index': item.index,
    //     'Tab Index': localIndex,
    //     'Heading': item.heading,
    //     'ID': item.id
    //   })));
    // });
    
    // Also log as simple arrays for easy reference
    // console.log('\n=== SIMPLE ARRAY INDICES BY TAB ===');
    Object.keys(groupedByTab).forEach(tabTitle => {
      const indices = groupedByTab[tabTitle].map(item => item.index);
      // console.log(`${tabTitle}: [${indices.join(', ')}]`);
    });
  }
  